<main id="main-content" class="h-screen flex flex-col pl-10 py-4 pr-4 transition-all duration-0">
    <div class="w-full flex flex-col p-2 items-center gap-2">
        <div class="w-full flex flex-row items-center justify-between">
            <div class="w-full flex gap-2 items-center justify-start">
                <h1 class="oswald-font text-3xl uppercase">
                    {{ title }}
                </h1>
                <div data-popover-target="popover-bottom" data-popover-placement="bottom" type="button">
                    <lucide-icon [name]="icons.CircleHelp" [size]=24 class="text-red-500"></lucide-icon>
                </div>
                <div data-popover id="popover-bottom" role="tooltip" class="absolute z-30 invisible inline-block w-fit max-w-[600px] text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-md shadow-xs opacity-0">
                    <div class="px-3 py-2 flex flex-col gap-1">
                        <p>
                            Listed below are all of the threats and hazards identified in Step 2 as well as their associated vulnerability and risk assessments. For each threat or hazard, click on 
                            <span class="px-3.5 py-1 inline-flex font-normal text-white oswald-font border border-nside-orange-300 bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 cursor-pointer">
                                Edit
                            </span>. In the pop-up, fill out the specific goals and objectives for the threat/hazard. When all sections have been completed, click on 
                            <span class="inline-flex px-3.5 py-1 flex items-center justify-center text-white oswald-font bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md">
                                Save
                            </span>.
                        </p>
                        <p>
                            To preview goals and objectives, click on 
                            <span class="inline-flex px-3.5 py-1 font-normal oswald-font border border-nside-gray-400 bg-white rounded-md">
                                Preview
                            </span>.Note** this button will not be available until all goals and objectives have been completed for the threat/hazard. 
                        </p>
                        <p>
                            To delete goals and objectives for a threat/hazard, click on 
                            <span class="inline-flex px-3.5 py-1 font-normal text-white oswald-font border border-nside-gray-300 bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 rounded-md"
                            >
                                Delete
                            </span>.Note** this button will not be available until all goals and objectives have been completed for the threat/hazard. This will only delete goals and objectives. This will not delete the threat/hazard.
                        </p>
                        <p>
                            Once completed, continue forward to create your <strong>Functional Assignments</strong>.
                        </p>
                    </div>
                    <div data-popper-arrow></div>
                </div>
            </div>
            <eop-assistant
                [sectionId]="eopSection"
            ></eop-assistant>        
        </div>
    </div>
    
    <!-- MAIN CONTENT -->
    <div class="p-2 w-full flex flex-grow flex-col items-start gap-8 overflow-y-auto">
        <div class="h-full w-full flex flex-col items-center justify-center gap-4">
            <div class="h-full w-full bg-white rounded-md shadow-custom-2 flex flex-col items-center justify-start p-6 gap-4">
                <div class="w-full h-10 flex items-center justify-between">
                    <div *ngIf="currentPageRoute?.toString() === 'hazard-school-ground'" class="pr-4 h-full">
                        <button id="dropdowndropdownAssessmentSectionsButton" data-dropdown-toggle="dropdownAssessmentSections" class="w-40 px-2.5 h-full rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 hover:from-nside-orange-100 hover:to-nside-orange-200 text-white oswald-font flex items-center justify-center gap-1 whitespace-nowrap" type="button">
                            {{ selectedSection ? (selectedSection.split('-')[1] || selectedSection) : 'All Sections' }}
                            <svg class="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
                            </svg>
                        </button>
                        <div id="dropdownAssessmentSections" class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-44">
                            <ul class="py-2 text-sm text-gray-700 bg-orange-50" aria-labelledby="dropdowndropdownAssessmentSectionsButton">
                                <li class="hover:bg-white">
                                    <button class="block px-4 py-2" (click)="onSectionChange('')">
                                        All Sections
                                    </button>
                                </li>
                                <li *ngFor="let item of assessmentByRoute[currentPageRoute]" class="hover:bg-white">
                                    <button 
                                        class="block px-4 py-2"
                                        (click)="$event.preventDefault(); onSectionChange(item);"
                                    >
                                        {{ item.split('-')[1] || item }}
                                    </button>
                                  </li>
                            </ul>
                        </div>
                    </div>
                    <div class="relative w-full h-full">
                        <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                            <lucide-icon [img]="icons.Search"></lucide-icon>
                        </div>
                        <input 
                            type="search" 
                            class="block w-full h-full p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500" 
                            [(ngModel)]="searchQuery" 
                            (input)="filterAssessmentsList()"
                            placeholder="Search..."  />
                    </div> 
                    <div *ngIf="canSave()" class="pl-4 h-full">
                        <button
                            class="min-w-fit max-w-[600px] px-2.5 h-full rounded-md border border-nside-gray-400 bg-white hover:bg-gray-100 bg-white oswald-font flex items-center justify-center gap-1 whitespace-nowrap"
                            (click)="$event.preventDefault(); handleOpenModal('new-assess');"
                        >
                            <lucide-icon [img]="icons.Plus"></lucide-icon>
                            <p>Add New Assessment</p>
                        </button>
                    </div>
                    <div *ngIf="canSave()" class="pl-4 h-full">
                        <button
                        class="min-w-fit max-w-[600px] px-2.5 h-full rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 hover:from-nside-orange-100 hover:to-nside-orange-200 text-white oswald-font flex items-center justify-center gap-1 whitespace-nowrap"
                            (click)="$event.preventDefault(); handleOpenModal('send-al-assess');">
                            <lucide-icon [img]="icons.Mail"></lucide-icon>
                            <p>Send Assessment</p>
                        </button>
                    </div>
                </div>
                <ng-container *ngIf="assessmentsList.length > 0; else emptyThreat">
                    <div class="h-full w-full overflow-y-auto">
                        <table class="w-full text-left">
                            <thead class="oswald-font text-gray-700 uppercase bg-main-background">
                                <tr>
                                    <th scope="col" class="h-12 px-4 py-3 py-3 w-10">
                                        <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                            No.
                                        </div>
                                    </th>
                                    <th *ngIf="currentAssessmentType === 'AL-Classroom'" scope="col" class="w-1/5 px-4 py-3">
                                        <div (click)="$event.preventDefault(); sortList('sub_type_name')" class="flex items-center justify-start gap-1 cursor-pointer">
                                            Room
                                            <lucide-icon [name]="icons.ArrowUpDown" [size]=24 class="ms-1"></lucide-icon>
                                        </div>
                                    </th>
                                    <th scope="col" class="w-1/5 px-4 py-3">
                                        <div (click)="$event.preventDefault(); sortList('sub_type_name')" class="flex items-center justify-start gap-1 cursor-pointer">
                                            Assessment Type
                                            <lucide-icon [name]="icons.ArrowUpDown" [size]=24 class="ms-1"></lucide-icon>
                                        </div>
                                    </th>
                                    <th scope="col" class="w-1/5 px-4 py-3">
                                        <div (click)="$event.preventDefault(); sortList('contact_name')" class="flex items-center justify-start gap-1 cursor-pointer">
                                            Survey By
                                            <lucide-icon [name]="icons.ArrowUpDown" [size]=24 class="ms-1"></lucide-icon>
                                        </div>
                                    </th>
                                    <th scope="col" class="w-1/5 px-4 py-3">
                                        <div class="flex items-center justify-start gap-1 cursor-pointer">
                                            Status
                                        </div>
                                    </th>
                                    <th scope="col" class="w-1/5 px-4 py-3">
                                        <div (click)="$event.preventDefault(); sortList('last_updated_user_name')" class="flex items-center justify-start gap-1 cursor-pointer">
                                            Last Updated
                                            <lucide-icon [name]="icons.ArrowUpDown" [size]=24 class="ms-1"></lucide-icon>
                                        </div>
                                    </th>
                                    <th scope="col" class="w-1/5 px-4 py-3">
                                        <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                            Actions
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of assessmentsList | paginate: { itemsPerPage: itemsPerPage, currentPage: page }; let i=index;" class="bg-white border-b">
                                    <th scope="row" class="px-4 py-4">
                                        {{ i + 1 + (page - 1) * itemsPerPage }} 
                                    </th>
                                    <th *ngIf="currentAssessmentType === 'AL-Classroom'" class="px-4 py-4 font-medium">
                                        <p class="w-full whitespace-nowrap text-start">{{ item.response_data["room_number"] }}</p>
                                    </th>
                                    <th class="px-4 py-4 font-medium">
                                        <p class="w-full whitespace-nowrap text-start">{{ item.sub_type_name }}</p>
                                    </th>
                                    <th class="px-4 py-4 font-medium">
                                        <p class="w-full whitespace-nowrap text-start">{{ item.contact_name }}</p>
                                    </th>
                                    <th class="px-4 py-4 font-medium">
                                        <p class="w-full whitespace-nowrap text-start">{{ item.submitted == 0 ? "Incompleted" : "Completed" }}</p>
                                    </th>
                                    <th class="px-4 py-4 font-medium">
                                        <p class="w-full whitespace-nowrap text-start">{{ item.last_updated_at | date: 'MM/dd/yyyy - HH:mm' }}</p>
                                    </th>
                                    <th class="px-4 py-4 font-medium flex gap-2">
                                        <button 
                                            (click)="$event.preventDefault(); handleOpenModal('edit-assess', item);"
                                            class="min-w-14 p-2 font-normal oswald-font border border-nside-gray-400 bg-white hover:bg-gray-100 bg-white rounded-md"
                                        >
                                            {{ canSave() ? "View/Edit" : "View" }}
                                        </button>
                                        <button 
                                            *ngIf="canSave()"
                                            (click)="$event.preventDefault(); handleOpenModal('delete-confirmation', item);"
                                            class="w-14 py-2 font-normal text-white oswald-font border border-nside-gray-300 bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 hover:bg-gradient-to-b hover:from-nside-gray-100 hover:to-nside-gray-200 rounded-md"
                                        >
                                            Delete
                                        </button>
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ng-container>
                <ng-template #emptyThreat>
                    <div class="w-full text-nside-gray-100 italic text-start">
                        Empty list
                    </div>
                </ng-template>
                <div class="w-full flex justify-between items-center">
                    <p>{{ assessmentsList.length }} in total</p>
                    <pagination-controls
                        *ngIf="assessmentsList.length > itemsPerPage" 
                        (pageChange)="page = $event"
                        previousLabel="Prev"
                        nextLabel="Next"
                        class="mt-2"
                    ></pagination-controls>
                </div>
            </div>
        </div>
    </div>

    <!-- APPROVE BUTTON -->
    <div class="w-full flex flex-col p-2 items-center gap-2">
        <div class="w-full bg-white rounded-md shadow-custom-2 p-6 flex gap-4 overflow-y-auto">
            <div
                class="w-full p-2 border-l-4 bg-gray-50 rounded-r-md flex items-end gap-2"
                [ngClass]="{
                'border-green-600': fullAssessmentsList.length > 0 && fullAssessmentsList[0].user_name_approved,
                'border-nside-gray-300': !(fullAssessmentsList.length > 0 && fullAssessmentsList[0].user_name_approved)
                }"
            >
                <div class="w-full flex flex-col items-start justify-between">
                    <p class="oswald-font font-normal">
                        Confirmed By:
                        <span class="raleway-font">
                        {{ fullAssessmentsList.length > 0 ? (fullAssessmentsList[0].user_name_approved || '') : '' }}
                        </span>
                    </p>
                    <p class="oswald-font font-normal">
                        Date Confirm:
                        <span class="raleway-font">
                        {{ fullAssessmentsList.length > 0 ? (fullAssessmentsList[0].date_approved | date: 'MM/dd/yyyy - HH:mm') : '' }}
                        </span>
                    </p>
                    <p *ngIf="canSave()" class="w-full text-end">
                        By clicking this button, I certify that this information is correct and does not need to be updated.
                    </p>
                </div>
                <button
                    *ngIf="canSave()"
                    class="w-20 flex items-center justify-center text-white oswald-font px-4 py-1.5 bg-gradient-to-b rounded-md"
                    [ngClass]="{
                        'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': fullAssessmentsList.length === 0,
                        'border-green-600 from-green-500 to-green-600 hover:from-green-500 hover:to-green-700': fullAssessmentsList.length > 0
                    }"
                    [disabled]="fullAssessmentsList.length === 0"
                    (click)="$event.preventDefault(); confirmAssessments()"
                >
                    Confirm
                </button>
            </div>
        </div>
    </div>

    <introduction></introduction>

    <!-- Spinner -->
    <div *ngIf="loading">
        <spinner></spinner>
    </div>

    <send-al-assessment
        *ngIf="showModalType === 'send-al-assess'"
        [assessType]="currentAssessmentType"
        (onClose)="handleCloseModal('send-al-assess')"
        (onSave)="handleSave($event, 'send-al-assess')"
    ></send-al-assessment>

    <edit-hazard-assessment
        *ngIf="showModalType === 'edit-assess'"
        [assessmentToEdit]="selectedAssessment"
        (onClose)="handleCloseModal('edit-assess')"
        (onSave)="handleSave($event, 'edit-assess')"
    ></edit-hazard-assessment>

    <new-hazard-assessment
        *ngIf="showModalType === 'new-assess'"
        (onClose)="handleCloseModal('new-assess')"
        (onSave)="handleSave($event, 'new-assess')"
    ></new-hazard-assessment>

    <delete-confirmation
        *ngIf="showModalType === 'delete-confirmation'"
        [text]="'this assessment'"
        [itemToDelete]="selectedAssessment"
        (onClose)="handleCloseModal('delete-confirmation')"
        (onDelete)="handleDelete($event)"
    ></delete-confirmation>

    <prv-next-buttons></prv-next-buttons>

    <popup-message 
        [type]="messageModal"
        [message]="popupMessage"
        (close)="resetMessageModal()"
    ></popup-message>
</main>